// src/pages/InstallmentPay.js
import React, { useState } from 'react';
import { useParams } from 'react-router-dom';
import axios from 'axios'
const InstallmentPay = () => {
  const { installmentId } = useParams();
  const [goldWeight, setGoldWeight] = useState('');

  const handlePay = async () => {
    if (!goldWeight || goldWeight <= 0) {
      alert('مقدار وزن طلا را وارد کنید');
      return;
    }

    try {
      const res = await axios.post('/payment/installment/pay', {
        installmentId,
        paidGoldWeight: goldWeight
      });

      if (res.data.success) {
        alert(`پرداخت موفق! باقی‌مانده: ${res.data.remaining_debt} گرم`);
        // ریدایرکت یا بروزرسانی
      }
    } catch (error) {
      alert('خطا در پرداخت');
    }
  };

  return (
    <div className="min-h-screen bg-gray-50 flex items-center justify-center py-20">
      <div className="bg-white rounded-3xl shadow-2xl p-12 max-w-md w-full">
        <h2 className="text-3xl font-bold text-gold-dark text-center mb-8">پرداخت قسط</h2>

        <div className="space-y-8">
          <div>
            <label className="block text-xl font-medium text-gray-700 mb-4">
              وزن طلا تحویلی (گرم)
            </label>
            <input
              type="number"
              step="0.001"
              value={goldWeight}
              onChange={(e) => setGoldWeight(e.target.value)}
              className="w-full px-6 py-5 text-2xl text-center border-2 border-gold/50 rounded-2xl focus:border-gold focus:outline-none"
              placeholder="0.123"
            />
          </div>

          <button
            onClick={handlePay}
            className="w-full bg-green-600 hover:bg-green-700 text-white font-bold py-6 rounded-2xl text-2xl transition shadow-xl"
          >
            تأیید و پرداخت قسط
          </button>
        </div>

        <p className="text-center text-sm text-gray-600 mt-8">
          می‌توانید بخشی از قسط یا کل آن را پرداخت کنید<br />
          پرداخت زودتر از موعد مجاز است
        </p>
      </div>
    </div>
  );
};

export default InstallmentPay;